import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-fourth-layer',
  templateUrl: './fourth-layer.component.html',
  styleUrls: ['./fourth-layer.component.scss']
})
export class FourthLayerComponent implements OnInit {
  @Input() itemsMenu: any;
  env = environment;
  path: string;
  receivedQS: any;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.path = params.get('id') || '';
      this.loadMenuForId(this.path);
    });
    this.route.queryParams.subscribe(params => {
      this.receivedQS = params;
    })
    console.log("ITEMMM", this.itemsMenu)
  }
  findById(tree: any[], id: string): any | undefined {
    for (const node of tree) {
      if (node.id === id) return node;
      const found = node.submenu && this.findById(node.submenu, id);
      if (found) return found;
    }
  }

  loadMenuForId(id: string) {
    this.itemsMenu = this.findById(this.env.Menu, id);
    console.log("itemsMenu:", this.itemsMenu);
  }

  navigate(path: string) {
    // separo path e queryParams usando le tue funzioni
    const queryParams = this.getQuerystring(path);
    const cleanPath = this.getPath(path);

    if (queryParams) {
      this.router.navigate([cleanPath], { queryParams: {...queryParams, ...this.receivedQS} });
    } else {
      this.router.navigate([cleanPath]);
    }
  }


  getQuerystring(path: string){
    if(!path?.includes('?')) {
      return null;
    }
     var queryString: string = path;
     var queryParams: any = {};
    // Estrai la parte della querystring dalla stringa completa
    const queryStringIndex =queryString.indexOf('?');
    const queryStringPart = queryString.slice(queryStringIndex + 1);

    // Dividi la querystring in coppie chiave-valore
    const keyValuePairs = queryStringPart.split('&');

    // Loop attraverso le coppie chiave-valore e crea l'oggetto JSON
    keyValuePairs.forEach(keyValuePair => {
      const [key, value] = keyValuePair.split('=');
      if (key && value) {
        queryParams[key] = decodeURIComponent(value);
      }
    });
    return queryParams;
  }

  getPath(queryString: string){

    if(queryString.includes('?')) {
      const queryStringIndex = queryString.indexOf('?');
      return queryString.slice(0, queryStringIndex !== -1 ? queryStringIndex : undefined);
    }
    return queryString;

  }

}
